import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ExportLogo.css';
import logo from '../Header/LOGO.svg'

 class ExportLogo extends React.Component {
  render () {
    const {brandId} = this.props;
    return (
      <div className={s.container}>
        <div className={s.exportLogo}>
          <img src={`/digitalAssets/resources/img/LOGO/${brandId}.png`} alt=""/>
        </div>
        <div className={s.exportWrapper}>
          <img src={logo} alt="数字品牌榜"/>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(ExportLogo);


// WEBPACK FOOTER //
// src/components/ExportLogo/ExportLogo.js